"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountDown = void 0;
var react_1 = __importDefault(require("react"));
exports.useCountDown = function (timeToCount, interval) {
    if (timeToCount === void 0) { timeToCount = 60 * 1000; }
    if (interval === void 0) { interval = 1000; }
    var _a = react_1.default.useState(0), timeLeft = _a[0], setTimeLeft = _a[1];
    var timer = react_1.default.useRef({});
    var run = function (ts) {
        if (!timer.current.started) {
            timer.current.started = ts;
            timer.current.lastInterval = ts;
        }
        var localInterval = Math.min(interval, (timer.current.timeLeft || Infinity));
        if ((ts - timer.current.lastInterval) >= localInterval) {
            timer.current.lastInterval += localInterval;
            setTimeLeft(function (timeLeft) {
                timer.current.timeLeft = timeLeft - localInterval;
                return timer.current.timeLeft;
            });
        }
        if (ts - timer.current.started < timer.current.timeToCount) {
            timer.current.requestId = window.requestAnimationFrame(run);
        }
        else {
            timer.current = {};
            setTimeLeft(0);
        }
    };
    var start = react_1.default.useCallback(function (ttc) {
        window.cancelAnimationFrame(timer.current.requestId);
        var newTimeToCount = ttc !== undefined ? ttc : timeToCount;
        timer.current.started = null;
        timer.current.lastInterval = null;
        timer.current.timeToCount = newTimeToCount;
        timer.current.requestId = window.requestAnimationFrame(run);
        setTimeLeft(newTimeToCount);
    }, []);
    var pause = react_1.default.useCallback(function () {
        window.cancelAnimationFrame(timer.current.requestId);
        timer.current.started = null;
        timer.current.lastInterval = null;
        timer.current.timeToCount = timer.current.timeLeft;
    }, []);
    var resume = react_1.default.useCallback(function () {
        if (!timer.current.started && timer.current.timeLeft > 0) {
            window.cancelAnimationFrame(timer.current.requestId);
            timer.current.requestId = window.requestAnimationFrame(run);
        }
    }, []);
    var reset = react_1.default.useCallback(function () {
        if (timer.current.timeLeft) {
            window.cancelAnimationFrame(timer.current.requestId);
            timer.current = {};
            setTimeLeft(0);
        }
    }, []);
    var actions = react_1.default.useMemo(function () { return ({ start: start, pause: pause, resume: resume, reset: reset }); }, []);
    react_1.default.useEffect(function () { return reset; }, []);
    return [timeLeft, actions];
};
